import Vue from 'Vue'
export default new Vue;



// WEBPACK FOOTER //
// ./src/service/center.js